$(document).ready(() => {

    // Truncate modal text

    // text_truncate = function (str, length, ending) {
    //         if (length == null) {
    //                 length = 100;
    //         }
    //         if (ending == null) {
    //                 ending = '...';
    //         }
    //         if (str.length > length) {
    //                 return str.substring(0, length - ending.length) + ending;
    //         } else {
    //                 return str;
    //         }
    // };
    // console.log(text_truncate('We are doing JS string exercises.'))
    // console.log(text_truncate('We are doing JS string exercises.', 19))
    // console.log(text_truncate('We are doing JS string exercises.', 15, '!!'))

    $('.social-proof').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 350,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });


    $('.testimonial-slider').owlCarousel({
        loop: true,
        navText: [$('.am-prev'), $('.am-next')],
        margin: 0,
        nav: true,
        dots: false,
        items: 1,
    });

    //  Highlight Proof Sliders
    // Bootstrap Triggers Slider 1
    $('.left').click((e) => {
        e.preventDefault();
        $('#productSliderOne, #productSliderTwo, #productSliderThree, #productSliderFour').carousel('prev');

        // $('#productSliderTwo').carousel('prev');
        // $('#productSliderThree').carousel('prev');
        // $('#productSliderFour').carousel('prev');
    });

    $('.right').click((e) => {
        e.preventDefault();
        $('#productSliderOne, #productSliderTwo, #productSliderThree, #productSliderFour').carousel('next');
        // $('#productSliderTwo').carousel('next');
        // $('#productSliderThree').carousel('next');
        // $('#productSliderFour').carousel('next');
    });



    // Image Point of Interests
    //open interest point description
    $('.cd-single-point').children('a').on('click', function() {
        var selectedPoint = $(this).parent('li');
        if (selectedPoint.hasClass('is-open')) {
            selectedPoint.removeClass('is-open').addClass('visited');
        } else {
            selectedPoint.addClass('is-open').siblings('.cd-single-point.is-open').removeClass('is-open').addClass('visited');
        }
    });
    //close interest point description
    $('.cd-close-info').on('click', function(event) {
        event.preventDefault();
        $(this).parents('.cd-single-point').eq(0).removeClass('is-open').addClass('visited');
    });

    // Wheel Click Modal
    $('button.btn-prime').on('mousedown', (e) => {
        if (e.which === 2) {
            e.preventDefault();
            e.stopPropagation();
            $(e.currentTarget).trigger('click');
        }
    });

    // Stops page jump on click
    $(".cd-img-replace").click(function(e) {
        e.preventDefault();
    });




	//Temporary message for Spring 2022 Launch out of stock products added by Dave Yankowiak:
	checkOutOfStock();

	var firstTimeUrl = document.URL;
    document.addEventListener('change', function() {
      
      var currentPageUrl = document.URL;
      var url = new URL(currentPageUrl);
      var isVariantUrl = url.searchParams.get("variant");
      currentPageUrl = isVariantUrl ? currentPageUrl :isVariantUrl;
        if(currentPageUrl && firstTimeUrl != currentPageUrl) {
          firstTimeUrl = currentPageUrl;
          console.log('variant_id: '+isVariantUrl+'')


          checkOutOfStock();

        }
    });

	function checkOutOfStock() {
      
      	// Linen - Sea Blue
        if (window.location.href.indexOf("variant=40307898581176") > -1 || window.location.href.indexOf("variant=40307900743864") > -1 || window.location.href.indexOf("variant=40307901956280") > -1) { //Sea Blue Linen
          //$(".shipping-late-notice").remove();
          //$("<div class='shipping-late-notice' style='margin-bottom:15px;'><strong>New! Shipping late March 2022.</strong></div>" ).insertBefore( ".form__control.q-control" );
        
        // Linen - Sienna
        } else if (window.location.href.indexOf("variant=40307865845944") > -1 || window.location.href.indexOf("variant=40307870335160") > -1 || window.location.href.indexOf("variant=40307872235704") > -1) { //Sienna Linen
          //$(".shipping-late-notice").remove();
          //$("<div class='shipping-late-notice' style='margin-bottom:15px;'><strong>New! Shipping late March 2022.</strong></div>" ).insertBefore( ".form__control.q-control" );
        
        // Portfolio
        } else if (window.location.href.indexOf("variant=40640223936696") > -1 || window.location.href.indexOf("variant=40640233013432") > -1 ) { //Portfolio
          //$(".shipping-late-notice").remove();
          //$("<div class='shipping-late-notice' style='margin-bottom:15px;'><strong>New! Shipping late March 2022.</strong></div>" ).insertBefore( ".form__control.q-control" );
        
        } else { //default
            $(".shipping-late-notice").remove();
        }
        

  	}
	// END Temporary message for Spring 2022 Launch

});